/* eslint-disable */
var o = new Array(
  16843776,
  0,
  65536,
  16843780,
  16842756,
  66564,
  4,
  65536,
  1024,
  16843776,
  16843780,
  1024,
  16778244,
  16842756,
  16777216,
  4,
  1028,
  16778240,
  16778240,
  66560,
  66560,
  16842752,
  16842752,
  16778244,
  65540,
  16777220,
  16777220,
  65540,
  0,
  1028,
  66564,
  16777216,
  65536,
  16843780,
  4,
  16842752,
  16843776,
  16777216,
  16777216,
  1024,
  16842756,
  65536,
  66560,
  16777220,
  1024,
  4,
  16778244,
  66564,
  16843780,
  65540,
  16842752,
  16778244,
  16777220,
  1028,
  66564,
  16843776,
  1028,
  16778240,
  16778240,
  0,
  65540,
  66560,
  0,
  16842756
);
var l = new Array(
  -2146402272,
  -2147450880,
  32768,
  1081376,
  1048576,
  32,
  -2146435040,
  -2147450848,
  -2147483616,
  -2146402272,
  -2146402304,
  -2147483648,
  -2147450880,
  1048576,
  32,
  -2146435040,
  1081344,
  1048608,
  -2147450848,
  0,
  -2147483648,
  32768,
  1081376,
  -2146435072,
  1048608,
  -2147483616,
  0,
  1081344,
  32800,
  -2146402304,
  -2146435072,
  32800,
  0,
  1081376,
  -2146435040,
  1048576,
  -2147450848,
  -2146435072,
  -2146402304,
  32768,
  -2146435072,
  -2147450880,
  32,
  -2146402272,
  1081376,
  32,
  32768,
  -2147483648,
  32800,
  -2146402304,
  1048576,
  -2147483616,
  1048608,
  -2147450848,
  -2147483616,
  1048608,
  1081344,
  0,
  -2147450880,
  32800,
  -2147483648,
  -2146435040,
  -2146402272,
  1081344
);
var j = new Array(
  520,
  134349312,
  0,
  134348808,
  134218240,
  0,
  131592,
  134218240,
  131080,
  134217736,
  134217736,
  131072,
  134349320,
  131080,
  134348800,
  520,
  134217728,
  8,
  134349312,
  512,
  131584,
  134348800,
  134348808,
  131592,
  134218248,
  131584,
  131072,
  134218248,
  8,
  134349320,
  512,
  134217728,
  134349312,
  134217728,
  131080,
  520,
  131072,
  134349312,
  134218240,
  0,
  512,
  131080,
  134349320,
  134218240,
  134217736,
  512,
  0,
  134348808,
  134218248,
  131072,
  134217728,
  134349320,
  8,
  131592,
  131584,
  134217736,
  134348800,
  134218248,
  520,
  134348800,
  131592,
  8,
  134348808,
  131584
);
var h = new Array(
  8396801,
  8321,
  8321,
  128,
  8396928,
  8388737,
  8388609,
  8193,
  0,
  8396800,
  8396800,
  8396929,
  129,
  0,
  8388736,
  8388609,
  1,
  8192,
  8388608,
  8396801,
  128,
  8388608,
  8193,
  8320,
  8388737,
  1,
  8320,
  8388736,
  8192,
  8396928,
  8396929,
  129,
  8388736,
  8388609,
  8396800,
  8396929,
  129,
  0,
  0,
  8396800,
  8320,
  8388736,
  8388737,
  1,
  8396801,
  8321,
  8321,
  128,
  8396929,
  129,
  1,
  8192,
  8388609,
  8193,
  8396928,
  8388737,
  8193,
  8320,
  8388608,
  8396801,
  128,
  8388608,
  8192,
  8396928
);
var f = new Array(
  256,
  34078976,
  34078720,
  1107296512,
  524288,
  256,
  1073741824,
  34078720,
  1074266368,
  524288,
  33554688,
  1074266368,
  1107296512,
  1107820544,
  524544,
  1073741824,
  33554432,
  1074266112,
  1074266112,
  0,
  1073742080,
  1107820800,
  1107820800,
  33554688,
  1107820544,
  1073742080,
  0,
  1107296256,
  34078976,
  33554432,
  1107296256,
  524544,
  524288,
  1107296512,
  256,
  33554432,
  1073741824,
  34078720,
  1107296512,
  1074266368,
  33554688,
  1073741824,
  1107820544,
  34078976,
  1074266368,
  256,
  33554432,
  1107820544,
  1107820800,
  524544,
  1107296256,
  1107820800,
  34078720,
  0,
  1074266112,
  1107296256,
  524544,
  33554688,
  1073742080,
  524288,
  0,
  1074266112,
  34078976,
  1073742080
);
var d = new Array(
  536870928,
  541065216,
  16384,
  541081616,
  541065216,
  16,
  541081616,
  4194304,
  536887296,
  4210704,
  4194304,
  536870928,
  4194320,
  536887296,
  536870912,
  16400,
  0,
  4194320,
  536887312,
  16384,
  4210688,
  536887312,
  16,
  541065232,
  541065232,
  0,
  4210704,
  541081600,
  16400,
  4210688,
  541081600,
  536870912,
  536887296,
  16,
  541065232,
  4210688,
  541081616,
  4194304,
  16400,
  536870928,
  4194304,
  536887296,
  536870912,
  16400,
  536870928,
  541081616,
  4210688,
  541065216,
  4210704,
  541081600,
  0,
  541065232,
  16,
  16384,
  541065216,
  4210704,
  16384,
  4194320,
  536887312,
  0,
  541081600,
  536870912,
  4194320,
  536887312
);
var c = new Array(
  2097152,
  69206018,
  67110914,
  0,
  2048,
  67110914,
  2099202,
  69208064,
  69208066,
  2097152,
  0,
  67108866,
  2,
  67108864,
  69206018,
  2050,
  67110912,
  2099202,
  2097154,
  67110912,
  67108866,
  69206016,
  69208064,
  2097154,
  69206016,
  2048,
  2050,
  69208066,
  2099200,
  2,
  67108864,
  2099200,
  67108864,
  2099200,
  2097152,
  67110914,
  67110914,
  69206018,
  69206018,
  2,
  2097154,
  67108864,
  67110912,
  2097152,
  69208064,
  2050,
  2099202,
  69208064,
  2050,
  67108866,
  69208066,
  69206016,
  2099200,
  0,
  2,
  69208066,
  0,
  2099202,
  69206016,
  2048,
  67108866,
  67110912,
  2048,
  2097154
);
var b = new Array(
  268439616,
  4096,
  262144,
  268701760,
  268435456,
  268439616,
  64,
  268435456,
  262208,
  268697600,
  268701760,
  266240,
  268701696,
  266304,
  4096,
  64,
  268697600,
  268435520,
  268439552,
  4160,
  266240,
  262208,
  268697664,
  268701696,
  4160,
  0,
  0,
  268697664,
  268435520,
  268439552,
  266304,
  262144,
  266304,
  262144,
  268701696,
  4096,
  64,
  268697664,
  4096,
  266304,
  268439552,
  64,
  268435520,
  268697600,
  268697664,
  268435456,
  262144,
  268439616,
  0,
  268701760,
  262208,
  268435520,
  268697600,
  268439552,
  268439616,
  0,
  268701760,
  266240,
  266240,
  4160,
  4160,
  262208,
  268435456,
  268701696
);
var y = new Array(
  0,
  4,
  536870912,
  536870916,
  65536,
  65540,
  536936448,
  536936452,
  512,
  516,
  536871424,
  536871428,
  66048,
  66052,
  536936960,
  536936964
);
var x = new Array(
  0,
  1,
  1048576,
  1048577,
  67108864,
  67108865,
  68157440,
  68157441,
  256,
  257,
  1048832,
  1048833,
  67109120,
  67109121,
  68157696,
  68157697
);
var w = new Array(
  0,
  8,
  2048,
  2056,
  16777216,
  16777224,
  16779264,
  16779272,
  0,
  8,
  2048,
  2056,
  16777216,
  16777224,
  16779264,
  16779272
);
var v = new Array(
  0,
  2097152,
  134217728,
  136314880,
  8192,
  2105344,
  134225920,
  136323072,
  131072,
  2228224,
  134348800,
  136445952,
  139264,
  2236416,
  134356992,
  136454144
);
var u = new Array(0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256);
var t = new Array(
  0,
  1024,
  32,
  1056,
  0,
  1024,
  32,
  1056,
  33554432,
  33555456,
  33554464,
  33555488,
  33554432,
  33555456,
  33554464,
  33555488
);
var s = new Array(
  0,
  268435456,
  524288,
  268959744,
  2,
  268435458,
  524290,
  268959746,
  0,
  268435456,
  524288,
  268959744,
  2,
  268435458,
  524290,
  268959746
);
var r = new Array(
  0,
  65536,
  2048,
  67584,
  536870912,
  536936448,
  536872960,
  536938496,
  131072,
  196608,
  133120,
  198656,
  537001984,
  537067520,
  537004032,
  537069568
);
var q = new Array(
  0,
  262144,
  0,
  262144,
  2,
  262146,
  2,
  262146,
  33554432,
  33816576,
  33554432,
  33816576,
  33554434,
  33816578,
  33554434,
  33816578
);
var p = new Array(
  0,
  268435456,
  8,
  268435464,
  0,
  268435456,
  8,
  268435464,
  1024,
  268436480,
  1032,
  268436488,
  1024,
  268436480,
  1032,
  268436488
);
var n = new Array(
  0,
  32,
  0,
  32,
  1048576,
  1048608,
  1048576,
  1048608,
  8192,
  8224,
  8192,
  8224,
  1056768,
  1056800,
  1056768,
  1056800
);
var k = new Array(
  0,
  16777216,
  512,
  16777728,
  2097152,
  18874368,
  2097664,
  18874880,
  67108864,
  83886080,
  67109376,
  83886592,
  69206016,
  85983232,
  69206528,
  85983744
);
var i = new Array(
  0,
  4096,
  134217728,
  134221824,
  524288,
  528384,
  134742016,
  134746112,
  16,
  4112,
  134217744,
  134221840,
  524304,
  528400,
  134742032,
  134746128
);
var g = new Array(0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261);
function e(Z, Y, M, J, E) {
  var L = a(Z);
  var O = 0,
    T,
    R,
    W,
    B,
    A,
    D,
    X,
    N;
  var G, Q, z, F;
  var K, P;
  var U = Y.length;
  var I = 0;
  var S = L.length === 32 ? 3 : 9;
  if (S === 3) {
    N = M ? new Array(0, 32, 2) : new Array(30, -2, -2);
  } else {
    N = M ? new Array(0, 32, 2, 62, 30, -2, 64, 96, 2) : new Array(94, 62, -2, 32, 64, 2, 30, -2, -2);
  }
  if (M) {
    var V = 8 - (U % 8);
    U += V;
    for (T = 0; T < 8; T++) {
      Y.push(V);
    }
  }
  var H = [];
  var C = [];
  if (J === 1) {
    G = (E[O++] << 24) | (E[O++] << 16) | (E[O++] << 8) | E[O++];
    z = (E[O++] << 24) | (E[O++] << 16) | (E[O++] << 8) | E[O];
    O = 0;
  }
  while (O < U) {
    D = (Y[O++] << 24) | (Y[O++] << 16) | (Y[O++] << 8) | Y[O++];
    X = (Y[O++] << 24) | (Y[O++] << 16) | (Y[O++] << 8) | Y[O++];
    if (J === 1) {
      if (M) {
        D ^= G;
        X ^= z;
      } else {
        Q = G;
        F = z;
        G = D;
        z = X;
      }
    }
    W = ((D >>> 4) ^ X) & 252645135;
    X ^= W;
    D ^= W << 4;
    W = ((D >>> 16) ^ X) & 65535;
    X ^= W;
    D ^= W << 16;
    W = ((X >>> 2) ^ D) & 858993459;
    D ^= W;
    X ^= W << 2;
    W = ((X >>> 8) ^ D) & 16711935;
    D ^= W;
    X ^= W << 8;
    W = ((D >>> 1) ^ X) & 1431655765;
    X ^= W;
    D ^= W << 1;
    D = (D << 1) | (D >>> 31);
    X = (X << 1) | (X >>> 31);
    for (R = 0; R < S; R += 3) {
      K = N[R + 1];
      P = N[R + 2];
      for (T = N[R]; T !== K; T += P) {
        B = X ^ L[T];
        A = ((X >>> 4) | (X << 28)) ^ L[T + 1];
        W = D;
        D = X;
        X =
          W ^
          (l[(B >>> 24) & 63] |
            h[(B >>> 16) & 63] |
            d[(B >>> 8) & 63] |
            b[B & 63] |
            o[(A >>> 24) & 63] |
            j[(A >>> 16) & 63] |
            f[(A >>> 8) & 63] |
            c[A & 63]);
      }
      W = D;
      D = X;
      X = W;
    }
    D = (D >>> 1) | (D << 31);
    X = (X >>> 1) | (X << 31);
    W = ((D >>> 1) ^ X) & 1431655765;
    X ^= W;
    D ^= W << 1;
    W = ((X >>> 8) ^ D) & 16711935;
    D ^= W;
    X ^= W << 8;
    W = ((X >>> 2) ^ D) & 858993459;
    D ^= W;
    X ^= W << 2;
    W = ((D >>> 16) ^ X) & 65535;
    X ^= W;
    D ^= W << 16;
    W = ((D >>> 4) ^ X) & 252645135;
    X ^= W;
    D ^= W << 4;
    if (J === 1) {
      if (M) {
        G = D;
        z = X;
      } else {
        D ^= Q;
        X ^= F;
      }
    }
    C.push(D >>> 24, (D >>> 16) & 255, (D >>> 8) & 255, D & 255, X >>> 24, (X >>> 16) & 255, (X >>> 8) & 255, X & 255);
    I = M ? I + 16 : I + 8;
    if (I === 512) {
      H = H.concat(C);
      C = [];
      I = 0;
    }
  }
  H = H.concat(C);
  if (!M) {
    H.length -= H[H.length - 1];
  }
  return H;
}
function a(J) {
  var C = J.length >= 24 ? 3 : 1;
  var L = new Array(32 * C);
  var H = new Array(0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0);
  var G,
    z,
    D = 0,
    A = 0,
    K;
  for (var E = 0; E < C; E++) {
    var B = (J.charCodeAt(D++) << 24) | (J.charCodeAt(D++) << 16) | (J.charCodeAt(D++) << 8) | J.charCodeAt(D++);
    var I = (J.charCodeAt(D++) << 24) | (J.charCodeAt(D++) << 16) | (J.charCodeAt(D++) << 8) | J.charCodeAt(D++);
    K = ((B >>> 4) ^ I) & 252645135;
    I ^= K;
    B ^= K << 4;
    K = ((I >>> -16) ^ B) & 65535;
    B ^= K;
    I ^= K << -16;
    K = ((B >>> 2) ^ I) & 858993459;
    I ^= K;
    B ^= K << 2;
    K = ((I >>> -16) ^ B) & 65535;
    B ^= K;
    I ^= K << -16;
    K = ((B >>> 1) ^ I) & 1431655765;
    I ^= K;
    B ^= K << 1;
    K = ((I >>> 8) ^ B) & 16711935;
    B ^= K;
    I ^= K << 8;
    K = ((B >>> 1) ^ I) & 1431655765;
    I ^= K;
    B ^= K << 1;
    K = (B << 8) | ((I >>> 20) & 240);
    B = (I << 24) | ((I << 8) & 16711680) | ((I >>> 8) & 65280) | ((I >>> 24) & 240);
    I = K;
    for (var F = 0; F < H.length; F++) {
      if (H[F]) {
        B = (B << 2) | (B >>> 26);
        I = (I << 2) | (I >>> 26);
      } else {
        B = (B << 1) | (B >>> 27);
        I = (I << 1) | (I >>> 27);
      }
      B &= -15;
      I &= -15;
      G =
        y[B >>> 28] |
        x[(B >>> 24) & 15] |
        w[(B >>> 20) & 15] |
        v[(B >>> 16) & 15] |
        u[(B >>> 12) & 15] |
        t[(B >>> 8) & 15] |
        s[(B >>> 4) & 15];
      z =
        r[I >>> 28] |
        q[(I >>> 24) & 15] |
        p[(I >>> 20) & 15] |
        n[(I >>> 16) & 15] |
        k[(I >>> 12) & 15] |
        i[(I >>> 8) & 15] |
        g[(I >>> 4) & 15];
      K = ((z >>> 16) ^ G) & 65535;
      L[A++] = G ^ K;
      L[A++] = z ^ (K << 16);
    }
  }
  return L;
}
function encrypt(A, B, z) {
  return e(A, B, 1, 0, z);
}

function string2Bytes(e, d) {
  var c,
    f,
    b = [];
  if (!d || d.toLowerCase() === 'unicode') {
    for (c = 0, f = e.length; c < f; c++) {
      b.push(e.charCodeAt(c) >> 8);
      b.push(e.charCodeAt(c) & 255);
    }
  } else {
    if (d.toLowerCase() === 'utf8') {
      e = unicode2Utf8(e);
    } else {
      if (d.toLowerCase() === 'gbk') {
        e = a.unicode2Ansi(e);
      } else {
        return null;
      }
    }
    for (c = 0, f = e.length; c < f; c++) {
      b.push(e.charCodeAt(c));
    }
  }
  return b;
}
function unicode2Utf8(f) {
  var c, b, e;
  var d = '';
  b = f.length;
  for (c = 0; c < b; c++) {
    e = f.charCodeAt(c);
    if (e >= 0 && e <= 127) {
      d += f.charAt(c);
    } else {
      if (e >= 128 && e <= 2047) {
        d += String.fromCharCode(192 | ((e >> 6) & 31));
        d += String.fromCharCode(128 | (e & 63));
      } else {
        if (e >= 2048 && e <= 65535) {
          d += String.fromCharCode(224 | ((e >> 12) & 15));
          d += String.fromCharCode(128 | ((e >> 6) & 63));
          d += String.fromCharCode(128 | (e & 63));
        } else {
          if (e >= 65536 && e <= 2097151) {
            d += String.fromCharCode(240 | ((e >> 18) & 7));
            d += String.fromCharCode(128 | ((e >> 12) & 63));
            d += String.fromCharCode(128 | ((e >> 6) & 63));
            d += String.fromCharCode(128 | (e & 63));
          } else {
            if (e >= 2097152 && e <= 67108863) {
              d += String.fromCharCode(248 | ((e >> 24) & 3));
              d += String.fromCharCode(128 | ((e >> 18) & 63));
              d += String.fromCharCode(128 | ((e >> 12) & 63));
              d += String.fromCharCode(128 | ((e >> 6) & 63));
              d += String.fromCharCode(128 | (e & 63));
            } else {
              if (e >= 67108864 && e <= 2147483647) {
                d += String.fromCharCode(252 | ((e >> 30) & 1));
                d += String.fromCharCode(128 | ((e >> 24) & 63));
                d += String.fromCharCode(128 | ((e >> 18) & 63));
                d += String.fromCharCode(128 | ((e >> 12) & 63));
                d += String.fromCharCode(128 | ((e >> 6) & 63));
                d += String.fromCharCode(128 | (e & 63));
              }
            }
          }
        }
      }
    }
  }
  return d;
}

function encode(j, k) {
  function d(f) {
    return f
      ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-.'
      : 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  }
  function b(f) {
    return f ? /[^A-Za-z0-9\._-]/g : /[^A-Za-z0-9\+\/=]/g;
  }
  function e(l, k) {
    var g = d(k);
    var h = [];
    var s, q, o;
    var r, p, n, m;
    var j = 0;
    if (l.length % 4 !== 0) {
      return '';
    }
    var f = b(k);
    if (f.exec(l)) {
      return '';
    }
    do {
      r = g.indexOf(l.charAt(j++));
      p = g.indexOf(l.charAt(j++));
      n = g.indexOf(l.charAt(j++));
      m = g.indexOf(l.charAt(j++));
      s = (r << 2) | (p >> 4);
      q = ((p & 15) << 4) | (n >> 2);
      o = ((n & 3) << 6) | m;
      h.push(s);
      if (n !== 64) {
        h.push(q);
      }
      if (m !== 64) {
        h.push(o);
      }
      s = q = o = '';
      r = p = n = m = '';
    } while (j < l.length);
    return h;
  }
  var f = d(k);
  var g = '';
  var r,
    p,
    n = '';
  var q,
    o,
    m,
    l = '';
  var h = 0;
  do {
    r = j[h++];
    p = j[h++];
    n = j[h++];
    q = r >> 2;
    o = ((r & 3) << 4) | (p >> 4);
    m = ((p & 15) << 2) | (n >> 6);
    l = n & 63;
    if (isNaN(p)) {
      m = l = 64;
    } else {
      if (isNaN(n)) {
        l = 64;
      }
    }
    g = g + f.charAt(q) + f.charAt(o) + f.charAt(m) + f.charAt(l);
    r = p = n = '';
    q = o = m = l = '';
  } while (h < j.length);
  return g;
}

const hexes = '0123456789ABCDEF'.split('');
function bytes2Hex(data) {
  let ret = '';
  let c;
  for (let i = 0, n = data.length; i < n; i++) {
    c = data[i] & 0xff;
    ret += hexes[c >> 4] + hexes[c & 0xf];
  }
  return ret;
}

export function encryptParamHex(param) {
  return bytes2Hex(encrypt('FaSVLBApOgwdmVCbOjzrEjyn', string2Bytes(param, 'utf8')));
}

export function encryptParamBase64(param) {
  return encode(encrypt('FaSVLBApOgwdmVCbOjzrEjyn', string2Bytes(param, 'utf8')));
}
